// Centralized environment configuration
export const environmentConfig = {
  // Node environment
  NODE_ENV: process.env.NODE_ENV || 'production',
  
  // API configuration
  NEXT_PUBLIC_BACKEND_URL: process.env.NEXT_PUBLIC_BACKEND_URL || (() => {
    throw new Error('CRITICAL: NEXT_PUBLIC_BACKEND_URL environment variable is not set. Application cannot start without this configuration.');
  })(),
  NEXT_PUBLIC_SITE_URL: process.env.NEXT_PUBLIC_SITE_URL || process.env.NEXT_PUBLIC_FRONTEND_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : (() => {
    throw new Error('CRITICAL: NEXT_PUBLIC_SITE_URL or NEXT_PUBLIC_FRONTEND_URL environment variable is not set. Application cannot start without this configuration.');
  })()),
  
  // Authentication configuration
  NEXT_PUBLIC_SECRET_KEY: process.env.NEXT_PUBLIC_SECRET_KEY || (process.env.NODE_ENV === 'development' ? 'dev-secret-key-for-local-development-only' : (() => {
    throw new Error('CRITICAL: NEXT_PUBLIC_SECRET_KEY environment variable is not set. Application cannot start without this security credential.');
  })()),
  NEXT_PUBLIC_SESSION_NAME: process.env.NEXT_PUBLIC_SESSION_NAME || "insuracentral-session",
  
  // Cloudflare Turnstile configuration
  NEXT_PUBLIC_TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY || "",
  
  // Feature flags
  NEXT_TELEMETRY_DISABLED: process.env.NEXT_TELEMETRY_DISABLED || "1",
  
  // CORS configuration
  CORS_ALLOWED_ORIGINS: process.env.CORS_ALLOWED_ORIGINS?.split(',') || [],
  FRONTEND_URL: process.env.FRONTEND_URL || process.env.NEXT_PUBLIC_FRONTEND_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : (() => {
    throw new Error('CRITICAL: FRONTEND_URL or NEXT_PUBLIC_FRONTEND_URL environment variable is not set. Application cannot start without this configuration.');
  })()),
};

// Helper functions
export const isDevelopment = (): boolean => {
  return environmentConfig.NODE_ENV === 'development';
};

export const isProduction = (): boolean => {
  return environmentConfig.NODE_ENV === 'production';
};

export const isStaging = (): boolean => {
  return environmentConfig.NODE_ENV === 'test';
};

export const shouldUseDryRun = (): boolean => {
  return !isProduction();
};

export const getEnvironment = (): string => {
  return environmentConfig.NODE_ENV;
};

// Debug helper
export const logEnvironmentConfig = (): void => {
  if (isDevelopment()) {
    // Development logging can be added here if needed
  }
};

// Validation helper
export const validateEnvironmentConfig = (): { isValid: boolean; errors: string[] } => {
  const errors: string[] = [];
  
  if (!environmentConfig.NEXT_PUBLIC_BACKEND_URL) {
    errors.push('NEXT_PUBLIC_BACKEND_URL is not configured');
  }
  
  if (!environmentConfig.NEXT_PUBLIC_BACKEND_URL.startsWith('https://')) {
    errors.push('NEXT_PUBLIC_BACKEND_URL should use HTTPS in production');
  }
  
  if (!environmentConfig.NEXT_PUBLIC_SECRET_KEY) {
    errors.push('NEXT_PUBLIC_SECRET_KEY is not configured');
  }
  
  if (!environmentConfig.NEXT_PUBLIC_SESSION_NAME) {
    errors.push('NEXT_PUBLIC_SESSION_NAME is not configured');
  }
  
  if (!environmentConfig.NEXT_PUBLIC_TURNSTILE_SITE_KEY) {
    errors.push('NEXT_PUBLIC_TURNSTILE_SITE_KEY is not configured');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
}; 